import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class CpaSinCtgConfirmadoDefinitivamente {
  static getListado () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cpa_descargada_sin_ctg_confirmado_definitivamente_listado`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
      .catch(lrsAdapter)
  }

  static getListadoTotales () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cpa_descargada_sin_ctg_confirmado_definitivamente_total`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
      .catch(lrsAdapter)
  }

  static confirmarDefinitivamente (numero) {
    const axios = getAxiosInstance()
    const promise = axios.put(`/carta_de_porte_automotor_ingreso`,
      `{"valores": {"estado_ctg": "D"}, "clave": {"numero": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
      .catch(lrsAdapter)
  }
}

export default CpaSinCtgConfirmadoDefinitivamente
